import { Star, Quote } from "lucide-react";
import Reveal from "@/components/Reveal";

const reviews = [
  {
    name: "Andreea M.",
    location: "București",
    initials: "AM",
    color: "bg-rose-500",
    text: "Am folosit GlobalTransport pentru transfer de la Otopeni la Mangalia. Șoferul a fost punctual, mașina impecabilă și prețul corect. Recomand cu încredere!",
    service: "Transfer Aeroport",
    rating: 5,
  },
  {
    name: "Cristian P.",
    location: "Constanța",
    initials: "CP",
    color: "bg-sky-500",
    text: "Servicii de top pentru grupul nostru de 4 persoane. Am mers la festivalul Neversea și înapoi — totul organizat perfect. Șoferul foarte prietenos!",
    service: "Transport Evenimente",
    rating: 5,
  },
  {
    name: "Ioana D.",
    location: "Mangalia",
    initials: "ID",
    color: "bg-emerald-500",
    text: "Am rezervat cursă pentru mamele mele către Vama Veche. Foarte comod, WhatsApp-ul face totul rapid. Voi apela sigur din nou.",
    service: "Cursă locală",
    rating: 5,
  },
  {
    name: "Mihai R.",
    location: "Cluj-Napoca",
    initials: "MR",
    color: "bg-violet-500",
    text: "Am ajuns la Beach, Please! Nibiru fără stres. Preț fix, șofer amabil, mașină curată. Exact ce trebuie pentru un festival relaxat.",
    service: "Festival BeachPlease",
    rating: 5,
  },
  {
    name: "Elena V.",
    location: "Timișoara",
    initials: "EV",
    color: "bg-amber-500",
    text: "Excursie de o zi pentru familie — de la Mangalia la Costinești și retur. Copiii au fost răsfățați, program flexibil, la 100% siguranță.",
    service: "Excursie personalizată",
    rating: 5,
  },
  {
    name: "Alexandru B.",
    location: "Brașov",
    initials: "AB",
    color: "bg-cyan-500",
    text: "Cea mai bună alegere pentru transferul de la Kogălniceanu. Am aterizat noaptea, șoferul era acolo, totul cash sau card, fără bătăi de cap.",
    service: "Transfer Aeroport",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section
      id="recenzii"
      data-testid="testimonials-section"
      className="py-20 lg:py-28 bg-slate-950 relative overflow-hidden"
    >
      <div className="absolute top-1/2 -translate-y-1/2 left-0 w-96 h-96 rounded-full bg-amber-500/5 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-amber-500/5 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <Reveal>
            <span className="text-amber-500 font-semibold text-sm uppercase tracking-widest">
              Recenzii
            </span>
            <h2
              data-testid="testimonials-title"
              className="mt-3 text-3xl lg:text-4xl font-bold text-white max-w-2xl mx-auto"
            >
              Ce spun clienții noștri despre GlobalTransport.
            </h2>
            <div className="mt-6 inline-flex items-center gap-2">
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-amber-500 text-amber-500" />
                ))}
              </div>
              <span className="text-slate-300 text-sm ml-2">
                <span className="font-bold text-white">4.9</span> din 5 · peste
                <span className="font-bold text-white"> 500+ </span>călătorii
              </span>
            </div>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r, i) => (
            <Reveal key={r.name} delay={i * 80}>
              <article
                data-testid={`testimonial-card-${i}`}
                className="group relative h-full bg-slate-900/70 backdrop-blur border border-slate-800 hover:border-amber-500/40 rounded-2xl p-6 lg:p-7 transition-all duration-300 hover:-translate-y-1"
              >
                <Quote
                  className="absolute top-5 right-5 w-8 h-8 text-amber-500/20 group-hover:text-amber-500/40 transition-colors"
                  strokeWidth={1.5}
                />

                <div className="flex items-center gap-1 mb-4">
                  {[...Array(r.rating)].map((_, k) => (
                    <Star
                      key={k}
                      className="w-4 h-4 fill-amber-500 text-amber-500"
                    />
                  ))}
                </div>

                <p className="text-slate-200 leading-relaxed text-[15px]">
                  "{r.text}"
                </p>

                <div className="mt-6 pt-5 border-t border-slate-800 flex items-center gap-3">
                  <div
                    className={`w-11 h-11 rounded-full ${r.color} text-white flex items-center justify-center font-semibold text-sm shrink-0`}
                    aria-hidden="true"
                  >
                    {r.initials}
                  </div>
                  <div className="min-w-0">
                    <div className="font-semibold text-white text-sm truncate">
                      {r.name}
                    </div>
                    <div className="text-xs text-slate-400 truncate">
                      {r.location} · {r.service}
                    </div>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <div className="mt-14 text-center">
          <p className="text-slate-400 text-sm">
            Vrei să fii următorul client mulțumit?{" "}
            <a
              href="#rezervare"
              data-testid="testimonials-cta"
              className="text-amber-500 hover:text-amber-400 font-semibold underline underline-offset-4"
            >
              Rezervă cursa ta acum →
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
